import { Component, Input, OnInit } from "@angular/core";
import { combineLatest, Observable, Subject, Subscription } from "rxjs";
import { distinctUntilChanged, map, takeUntil } from "rxjs/operators";
import { VideoSplitService } from "../video-split/video-split.service";
import { Preset } from "./../preset.model";
import { PresetService } from "./../preset.service";

@Component({
  selector: "app-presets",
  templateUrl: "./presets.component.html",
  styleUrls: ["./presets.component.scss"],
})
export class PresetsComponent implements OnInit {
  @Input() query$!: Observable<string>;
  private _unsubscribeAll$ = new Subject();
  querySubscription: Subscription;
  currentPresetId = 0;

  presets$ = this.presetService.presets$;
  filteredPresets$: Observable<Preset[]> = this.presets$;
  searchString: string;
  constructor(
    private presetService: PresetService,
    private videoSplitService: VideoSplitService
  ) {}

  ngOnInit(): void {
    const query$ = this.query$.pipe(
      map((q) => (q || "").trim().toLowerCase()),
      distinctUntilChanged()
    );
    this.presetService.getPresets().subscribe();
    this.filteredPresets$ = combineLatest([this.presets$, query$]).pipe(
      takeUntil(this._unsubscribeAll$),
      map(([presets, q]) => {
        return (presets || []).filter((p) =>
        (p.name || "").toLowerCase().includes(q)
        );
      })
    );
    this.videoSplitService.currentPreset$.pipe(takeUntil(this._unsubscribeAll$)).subscribe(preset => 
      { 
        this.currentPresetId = preset?.id ?? 0;
      }
    );
  }

  layoutIdToSymbol(id: number) {
    return this.presetService.layoutIdSymbolMap.get(id);
  }

  loadPreset(preset: Preset) {
    this.videoSplitService.loadPreset(preset);
  }

  showPreset(preset: Preset) {
    this.presetService.showPreset(preset, "showPreset");
  }

  deletePreset(pId: number) {
    this.presetService.removePreset(pId);
  }

  ngOnDestroy() {
    this.querySubscription.unsubscribe();
    this._unsubscribeAll$.next();
  }
}
